import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

// IE 11 Fetch support
import "isomorphic-fetch"

import routerFactory from './router'
import i18n from './i18n'

// idk
Vue.config.productionTip = false;

// Datetime conversion
Vue.use(require('vue-moment'));

let router = routerFactory.create(i18n);

// HTTP Post
import VueResource from 'vue-resource';
Vue.use(VueResource);

Vue.prototype.$settings = new Vue({
  data() {
    return {
      locales: []
    }
  },
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
